
import React from 'react';
import BusRatesTable from './BusRatesTable';


const Packages = () => {
  return (
   <div>

 <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Packages
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

       



    {/* <CabRatesTable/> */}
<BusRatesTable/>

<div className="rules-guidelines container">
  <div className="rules-card">
    <h2 className="rules-title">Rules & Guidelines</h2>

    <ul className="rules-list">
      <li>🚗 Driver allowance will be charged extra.</li>

      <li>📏 Cab running limit is 300 km per day.</li>

      <li>
        ⏰ Time: 6:00 AM to 10:00 PM. Cab must be returned by 10:00 PM.
        Extra charges apply after 10:00 PM. Night charges apply from 12:00 AM to 6:00 AM.
      </li>

      <li>📍 Time and km are calculated from office to office.</li>

      <li>🧾 Interstate tax, toll, parking & service tax are charged as actuals.</li>

      <li>💰 Extra km and extra hours will be charged separately as per rules.</li>

      <li>
        ⛽ Charges are based on current fuel price. Any fuel hike will affect rates.
      </li>
    </ul>
  </div>
</div>

   </div>
  );
};

export default Packages;
